<script setup lang="ts">
// Vue & Plugins
import { Ref, ref, useTemplateRef } from 'vue'

// Models
import { Skill } from '../../models/skill'

const { skills } = defineProps<{
    skills: Skill[]
}>()

const isShown: Ref<boolean> = ref(false)

const popover = useTemplateRef('popover-skills')
const toggle = (event: Event) => {
  isShown.value = !isShown.value

  popover.value?.toggle(event)
}
</script>

<template>
  <div
    v-bind="$attrs"
    class="flex items-center gap-x-2"
    @mouseenter="toggle"
    @mouseleave="toggle"
  >
    <slot name="default">
      <OverlayBadge
        v-for="skill in skills.slice(0, 1)"
        :key="skill.id"
        :value="skill?.type?.name"
        size="small"
        :pt:pcbadge:root:class="{
          'hidden': skill?.type?.name === null || skill?.type?.name === undefined,
          '-translate-y-3/4': true,
          '!start-0': true,
          'text-ellipsis overflow-hidden whitespace-nowrap': true,
        }"
        :pt:pcbadge:root:style="{
          'inset-inline-end': 'inherit',
        }"
      >
        <Tag
          :value="skill?.name"
          severity="secondary"
          :pt:label:class="{
            'text-ellipsis overflow-hidden whitespace-nowrap': true,
          }"
        />
      </OverlayBadge>
            
      <span
        v-if="skills && skills.length > 1"
        class="text-ellipsis overflow-hidden whitespace-nowrap text-muted-color text-sm"
      >{{ '+ ' + (skills.length - 1) + ' more' }}</span>
    </slot>
  </div>

  <Popover
    ref="popover-skills"
    @hide="isShown = false"
  >
    <div class="flex flex-col gap-4 w-[25rem]">
      <ul 
        class="list-none p-0 m-0 flex flex-col gap-4"
      >
        <li
          v-for="skill in skills"
          :key="skill.id"
          class="flex items-center gap-2"
        >
          <div>
            <span class="font-medium">{{ skill.name }}</span>
          </div>

          <div 
            v-if="skill.type"
            class="flex items-center gap-2 ml-auto text-sm"
          >
            <Tag
              :value="skill.type?.name"
            />
          </div>
        </li>
      </ul>
    </div>
  </Popover>
</template>
